// @flow

import actionCreators from "@modules/profile/actionCreator";
import http from "@http";
import config from "@config";
import { GetNotificationContacts } from "@modules/profile/constants/actions";
import { all, call, put, takeEvery, select } from "redux-saga/effects";
import { getMyEmployeesPage } from "@modules/profile/selectors";
import type { Action } from "redux-action";

type NotificationContactsRequest = $Exact<{
  page?: number,
}>;

export function* onGetNotificationContacts({
  payload,
}: Action<NotificationContactsRequest>): Generator<*, void, Object> {
  const currentPage = yield select(getMyEmployeesPage);
  const page = (payload && payload.page) || currentPage;

  try {
    const response = yield call(http.get, "/api/v1/my-details/notification-contact/my-employee", {
      params: {
        page,
        limit: config.resultsPerPage,
      },
    });

    yield put(actionCreators.GetNotificationContactsSuccess(response.data));
  } catch (e) {
    yield put(actionCreators.GetNotificationContactsError(e.response));
  }
}

export default function* MyDetailsSaga(): Generator<*, void, void> {
  yield all([takeEvery(GetNotificationContacts, onGetNotificationContacts)]);
}
